import { gql } from 'graphql-request';

import {
  ProductSetDownloadUrlsClassName,
  ProductSetDownloadUrlsID,
  ProductSetDownloadUrlsType,
  ProductSetDownloadUrlsUrl,
  ProductSetDownloadUrlsUUID,
  ProductsSetID,
  ProductsSetUUID
} from '../productsSetsTypes';

export interface FetchProductsSetDownloadUrlsQueryResponse {
  id: ProductsSetID;
  uuid: ProductsSetUUID;
  downloadUrls: {
    url: ProductSetDownloadUrlsUrl;
    id: ProductSetDownloadUrlsID;
    uuid: ProductSetDownloadUrlsUUID;
    type: ProductSetDownloadUrlsType;
    className: ProductSetDownloadUrlsClassName;
  }[];
}

export const FETCH_PRODUCTS_SET_DOWNLOAD_URLS_QUERY = gql`
  query ProductsSetDownloadUrls($uuid: ID!) {
    productsSet(uuid: $uuid) {
      id
      uuid
      downloadUrls {
        className
        url
        id
        uuid
        type
      }
    }
  }
`;
